<div class="list-container">
  <h1 class="text-2xl font-bold mb-4">{{ 'ROLES.LIST.TITLE' | translate }}</h1>

  <div class="overflow-x-auto mt-2">
    <table class="table-auto w-full border-collapse border border-slate-400">
      <thead>
      <tr class="bg-neutral-100 dark:bg-neutral-700">
        <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'ROLES.LIST.NAME' | translate }}</th>
        <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'ROLES.LIST.NORMALIZED_NAME' | translate }}</th>
      </tr>
      </thead>
      <tbody>
        @for (user of roles; track user.normalizedName; let even = $even) {
          <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ user.name }}</td>
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ user.normalizedName }}</td>
          </tr>
        } @empty {
          <tr>
            <td colspan="8" class="bg-neutral-50 dark:bg-neutral-800">
              @if (loading) {
                <div class="my-4">
                  <app-loading size="large" color="primary" />
                </div>
              } @else {
                {{ 'PAGINATION.NO_ITEMS' | translate }}
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
